import React from 'react';
import { ReactComponent as Truck } from '../../common/icons/truck.svg';
import { HTMLSectionWithLink } from './elements/Link';
import Card, { Threshold } from './Card';

export default ({ offer }) => (
  <Card offer={offer} image={<Truck />} originalPrice={offer.original_price}>
    <Threshold offer={offer}>
      {({ passed }) => {
        if (passed) {
          return (
            <HTMLSectionWithLink>
              {offer.subtitle_over_threshold || 'free shipping'}
            </HTMLSectionWithLink>
          );
        }
        return (
          <HTMLSectionWithLink>
            {offer.subtitle_under_threshold || 'to get free shipping'}
          </HTMLSectionWithLink>
        );
      }}
    </Threshold>
  </Card>
);
